import { Box, Button, Typography } from '@mui/material'
import { createFileRoute } from '@tanstack/react-router'
import { useEffect, useState } from 'react'
import TimeSelectionCard from '@components/TimeSelectionCard/TimeSelectionCard.component'
import useMainStore from '../../store/useMainStore'
import { useNavigate } from '@tanstack/react-router'
import userInviteStore from 'store/userInviteStore'

export const Route = createFileRoute('/(partner)/_partner/interview-duration')({
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = useNavigate()

  const [readTime, setReadTime] = useState(0);
  const [answerTime, setAnswerTime] = useState(0);
  const {userData, updateUserData} = userInviteStore();

  useEffect(() => {
    updateUserData({
      readTime: readTime,
      answerTime: answerTime,
    })
  }, [answerTime, readTime])

  const handleNext = () => {
    navigate({
      to: '/invite-user',
    })
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '32px',
      }}
    >
      <Box
        sx={{
          textAlign: 'center',
          maxWidth: '560px',
        }}
      >
        <Typography variant="h2" sx={{ pb: '8px' }}>
          Interview Duration
        </Typography>
        <Typography>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem, facilis.
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '22px',
          width: '100%',
        }}
      >
        <TimeSelectionCard
          title="How much time do candidates have to read the question?"
          description="Adjust read time"
          value={readTime}
          onChange={setReadTime}
          max={300}
          min={0}
        />
        <TimeSelectionCard
          title="How much time do candidates have to answer the question?"
          description="Adjust answer time"
          value={answerTime}
          onChange={setAnswerTime}
          max={300}
          min={0}
        />
      </Box>

      <Button
        variant="contained"
        fullWidth
        onClick={handleNext}
        disabled={readTime == null || answerTime == null}
      >
        Next
      </Button>
    </Box>
  )
}
